<template>
  <section class="intensive-inner">
    <div class="container _py-16 _px-md-4 _px-sm-0">
      <div class="hngrow-materials__list d-grid row-1-1 gap-32 _mt-6">
        <div
          v-if="
            getIntensiveDetail.children && getIntensiveDetail.children.length
          "
        >
          <SectionCard
            @click.native="
              toPage({
                name: 'Intensive',
                params: { slug: item.slug },
              })
            "
            v-for="(item, ind) in fixed"
            :key="ind"
            :item="item"
          >
            <template v-slot:image>
              <img :src="item.image" alt="" />
            </template>
          </SectionCard>
        </div>
        <VideoCard
          @like="like"
          @favorite="favorite"
          @downloadFile="downloadFile"
          @setVideoProgress="setVideoProgress"
          @viewItem="viewItem"
          v-for="(block, ind) in blocks"
          :key="block.id"
          :item="block"
          :analyticEventPrefix="'intensive_lesson_material'"
        >
          <template v-slot:button>
            <div>
              <AppBtn
                v-if="block.check_list"
                @click.native="openCheckList(block)"
                :btnClass="'btn_secondary'"
                class="_mb-4 _mt-4"
              >
                <span class="d-flex _py-4 _px-6 _ml-sm-4">
                  <svg
                    class="_mr-2"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
                      stroke="#629727"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="_fs-16 _lh-24 _fw-500">{{
                    $t('interface.video.check_list')
                  }}</span></span
                ></AppBtn
              >
              <div class="d-flex align-center">
                <AppBtn
                  v-if="block.test"
                  @click.native="openTest(block, ind)"
                  :btnClass="'btn_secondary'"
                >
                  <span class="d-flex _py-4 _px-6 _ml-sm-4">
                    <svg
                      class="_mr-2"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 7C12 5.93913 11.5786 4.92172 10.8284 4.17157C10.0783 3.42143 9.06087 3 8 3H2V18H9C9.79565 18 10.5587 18.3161 11.1213 18.8787C11.6839 19.4413 12 20.2044 12 21M12 7V21M12 7C12 5.93913 12.4214 4.92172 13.1716 4.17157C13.9217 3.42143 14.9391 3 16 3H22V18H15C14.2044 18 13.4413 18.3161 12.8787 18.8787C12.3161 19.4413 12 20.2044 12 21"
                        stroke="#629727"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span class="_fs-16 _lh-24 _fw-500">{{
                      $t('interface.video.test')
                    }}</span></span
                  >
                </AppBtn>
                <div
                  class="_ml-4 _fs-16 _tc-green-main _lh-24"
                  v-if="block.test && block.test.view"
                >
                  {{ $t('pages.intensive_detail.progress.complete') }}
                </div>
              </div>
            </div>
          </template>
        </VideoCard>
      </div>
    </div>
    <Modal :key="remounter" v-if="testState" @close="closeQuestion">
      <template v-slot:modalBody>
        <div class="intensive-test">
          <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
            {{
              $t('pages.intensive_detail.test.training') + ' ' + trainingNumber
            }}
          </div>
          <div class="_fs-20 _lh-24 _tc-dark _fw-700 _mb-8">
            {{ currentBlock.title }}
          </div>
          <Question
            @addCorrectQuestion="addCorrectQuestion"
            @prevQuestion="prevQuestion"
            @nextQuestion="nextQuestion"
            :question="question"
            v-for="(question, qInd) in questionsSort"
            :qInd="parseInt(qInd)"
            :key="question.id"
            v-show="qInd === currentQuestion"
          />
          <div v-show="currentQuestion > questionsSort.length - 1">
            <div class="_fs-16 _lh-24 _tc-dark-grey _mb-2">
              {{
                $t('pages.intensive_detail.test.questions_1') +
                ' ' +
                correctQuestions
              }}
              {{
                $t('pages.intensive_detail.test.questions_2') +
                ' ' +
                questionsSort.length
              }}
            </div>
            <div class="_fs-24 _lh-32 _tc-dark _mb-6"></div>
            <div class="d-md-flex _mt-8 d-block">
              <AppBtn
                class="w-md-auto w-100 _mb-sm-4"
                :btnClass="'btn_secondary'"
                @click.native="remountTest"
                ><span class="_fs-16 _lh-24 _py-4 _px-4">{{
                  $t('pages.intensive_detail.test.again')
                }}</span>
              </AppBtn>
              <AppBtn
                @click.native="finishTest"
                class="_ml-auto w-md-auto w-100"
                ><span class="_fs-16 _lh-24 _py-4 _px-4">{{
                  $t('pages.intensive_detail.test.finish')
                }}</span>
              </AppBtn>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import SectionCard from '@/components/UI/cards/SectionCard'
import VideoCard from '@/components/UI/cards/VideoCard'
import AppBtn from '../../components/UI/buttons/AppBtn.vue'
import download from '@/mixins/download'
import toPage from '@/mixins/toPage'
import { mapActions, mapGetters } from 'vuex'
import Modal from '../../components/UI/Modal.vue'
import { bus } from '@/main'
import Question from '../../components/UI/intensives/Test/Question.vue'
export default {
  name: 'IntensiveDetail',
  components: {
    VideoCard,
    SectionCard,
    AppBtn,
    Modal,
    Question,
  },

  data: () => ({
    remounter: 0,
    trainingNumber: 0,
    currentBlock: null,
    currentQuestion: 0,
    testState: false,
    correctQuestions: 0,
  }),
  mixins: [download, toPage],
  computed: {
    ...mapGetters(['getIntensiveDetail']),
    currentLocale() {
      return this.Trans.currentLocale
    },
    currentTranslate() {
      return this.getIntensiveDetail.translates[0]
    },
    blocks() {
      const vm = this

      if (this.$route.params.filtered) {
        return this.getIntensiveDetail.lessons
          ?.filter(
            (el) =>
              el.translates &&
              el.translates.length &&
              (!el.view || (el.tests[0] ? !el.tests[0].view : true))
          )
          .map(function (el) {
            return {
              ...el,
              file: vm.getTranslate(el).video,
              title: vm.getTranslate(el).title,
              description: vm.getTranslate(el).description,
              preview: vm.getTranslate(el).preview,
              check_list: vm.getTranslate(el).check_list,
              file_size: vm.getTranslate(el).video_size,
              test: el.tests[0] || false,
              extras: vm.getTranslate(el).extras,
              speakers: el.speakers.map((el) => vm.getTranslate(el)),
            }
          })
      }
      return this.getIntensiveDetail.lessons
        ?.filter((el) => el.translates && el.translates.length)
        .map(function (el) {
          return {
            ...el,
            file: vm.getTranslate(el).video,
            title: vm.getTranslate(el).title,
            description: vm.getTranslate(el).description,
            preview: vm.getTranslate(el).preview,
            check_list: vm.getTranslate(el).check_list,
            file_size: vm.getTranslate(el).video_size,
            test: el.tests[0] || false,
            extras: vm.getTranslate(el).extras,
            speakers: el.speakers.map((el) => vm.getTranslate(el)),
          }
        })
    },
    fixed() {
      const vm = this
      return this.getIntensiveDetail.children.map(function (el) {
        return {
          title: vm.getTranslate(el).title,
          slug: el.slug,
          description: vm.getTranslate(el).description,
          image: vm.getTranslate(el).preview_thumbnail,
          speaker: `<span style="color: #629727; font-weight: 700">${vm.$t(
            'pages.intensive_detail.fixed.speaker'
          )}</span> <br>  ${el.speakers
            .map(function (el) {
              return `<p class="_mt-2">${
                vm.getTranslate(el).name
              }, ${vm.getTranslate(el).description}</p>`
            })
            .join('')}</span>`,
        }
      })
    },
    questionsSort() {
      if (!this.currentBlock) return false
      return this.currentBlock.test.questions
        .slice(0)
        .sort(() => Math.random() - 0.5)
    },
  },
  methods: {
    ...mapActions([
      'IntensiveSetVideoProgress',
      'fetchIntensiveDetail',
      'IntensiveSetFavorite',
      'IntensiveSetLike',
      'IntensiveSetView',
      'IntensiveTestSetView',
      'IntensivesTotalProgress',
      'clearScreencastsList',
    ]),
    modalToggle(model, state) {
      this[model] = state
      this.currentQuestion = 0
      bus.$emit('scrollLock', state)
    },
    closeQuestion() {
      this.remountTest()
      this.modalToggle('testState', false)
    },
    openTest(block, index) {
      this.currentBlock = null
      this.testState = true
      this.trainingNumber = index + 1
      this.currentQuestion = 0
      this.currentBlock = block
      bus.$emit('scrollLock', true)
      if (this.$gtm) {
        this.$gtm.push({
          event: 'intensive_lesson_test_start',
          param_value: this.helpers.stripHtml(block.title),
        })
      }
    },
    get_url_extension(url) {
      return url.split(/[#?]/)[0].split('.').pop().trim()
    },
    openCheckList(block) {
      this.downloadFile(
        block.check_list,
        `Чек-лист ${block.title}.${this.get_url_extension(block.check_list)}`
      )
      if (this.$gtm) {
        this.$gtm.push({
          event: 'intensive_lesson_checklist',
          param_value: this.helpers.stripHtml(block.title),
        })
      }
    },
    async updateList() {
      await this.fetchIntensiveDetail({
        lang: this.currentLocale,
        slug: this.$route.params.slug,
      })
    },
    async like(id) {
      await this.IntensiveSetLike(id)
      await this.updateList()
    },
    async favorite(id) {
      await this.IntensiveSetFavorite(id)
      await this.updateList()
    },
    async setVideoProgress(id, time) {
      await this.IntensiveSetVideoProgress({
        id: id,
        progress: Math.round(time),
      })
      await this.updateList()
    },
    getTranslate(item) {
      return item.translates[0]
    },
    prevQuestion() {
      this.currentQuestion--
    },
    nextQuestion() {
      this.currentQuestion++
    },
    addCorrectQuestion() {
      this.correctQuestions++
    },
    finishTest() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'intensive_lesson_test_btn_finish',
          param_value: this.helpers.stripHtml(this.currentBlock.title),
        })
      }
      this.modalToggle('testState', false)
      this.currentQuestion = 0
      this.correctQuestions = 0
    },
    remountTest() {
      let i = this.remounter
      this.currentQuestion = 0
      this.correctQuestions = 0
      while (i === this.remounter) {
        const min = 1
        const max = 999999
        this.remounter = Math.floor(Math.random() * (max - min) + min)
      }
      if (this.$gtm) {
        this.$gtm.push({
          event: 'intensive_lesson_test_btn_repeat',
          param_value: this.helpers.stripHtml(this.currentBlock.title),
        })
      }
    },
    async viewItem(id) {
      await this.IntensiveSetView(id)
      await this.updateList()
      await this.IntensivesTotalProgress()
    },
  },
  async mounted() {},
  async beforeDestroy() {
    this.clearScreencastsList()
  },
  watch: {
    async currentQuestion() {
      if (this.currentQuestion > this.questionsSort.length - 1) {
        if (!this.currentBlock.test.view) {
          await this.IntensiveTestSetView(this.currentBlock.test.id)
        }

        await this.updateList()
        await this.IntensivesTotalProgress()
        if (this.$gtm) {
          this.$gtm.push({
            event: 'intensive_lesson_test_end',
            param_value: this.helpers.stripHtml(this.currentBlock.title),
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.intensive-inner {
  background-color: #f8f8f8;
  .card-btn {
    display: flex;
    max-width: fit-content;
  }
}
</style>
